import type { Preview } from '@module/GraphQL';
import Query from './GetCareersPosts.gql';
import { type ImageAssets } from '@graphql/_fragments/blocks/Image';
// import { gql } from '@apollo/client/core';

export const GetCareersPostsQuery = Query; /*gql(`
${Query.loc?.source.body}
${ImageAsset.loc?.source.body}
`);*/

export interface CareersPostsDefaultEntry {
  __typename: "careersPosts_default_Entry";
  id: string;
  siteId: number;
  sectionHandle: string;
  typeHandle: string;
  title: string;
  slug: string;
  uri: string;
  url: string;
  blogFeaturedImage: ImageAssets | null;
  tags: Array<{
    title: string;
    slug: string;
    url: string;
  }> | null;
  categoryNames: Array<string> | null;
  categoryValues: Array<string> | null;
};

export interface GetCareersPostsVariables {
  site?: string | string[];
  section?: string | string[];
  topic?: string | string[];
  relatedToEntries?: EntryCriteriaInput | Array<EntryCriteriaInput>
  id?: string | string[];
  orderBy?: string;
  limit?: number;
  offset?: number;
  featured?: boolean;
  tagsLimit?: number;
  thumbnailWidth?: number; // 640
  thumbnailHeight?: number; // 320
};

export interface GetCareersPostsResponse {
  entryCount: number;
  tops: Array<CareersPostsDefaultEntry>;
  entries: Array<CareersPostsDefaultEntry>;
};